import PropTypes from 'prop-types';
import React from 'react';
import './style.css';

const CheckboxInput = ({ name, label, labelStyle, overrideCheckboxLabel, onChange, value, disabled, error }) => {
    var checkStyle = {
        color: '#222',
        padding: '10px'
    };

    var localV = '';
    if (value === true || value === 'true')
        localV = 'on';

    function customRet(evt) {
        var app = !(localV === 'on');
        evt.target.value = app;
        onChange(evt);
    }

    if (!disabled)
        disabled = false;

    let cssLabel = 'checkboxLabel';
    if (overrideCheckboxLabel)
        cssLabel = 'checkboxLabel overrideCheckboxLabel';

    return (
        <div style={checkStyle}>
            <input type="checkbox"
                disabled={disabled}
                className="checkbox"
                id={name}
                name={name}
                checked={localV}
                onChange={(evt) => customRet(evt)} />
            <label htmlFor={name} className={cssLabel} style={labelStyle}>{label}</label>
        </div>
    );
};

CheckboxInput.propTypes = {
    disabled: PropTypes.bool,
    error: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    labelStyle: PropTypes.object,
    overrideCheckboxLabel: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

export default CheckboxInput;